import { HttpClient } from '@angular/common/http';
import {
	inject,
	Injectable,
	InjectionToken,
	TransferState,
} from '@angular/core';

import type { HALResponse } from '@valk-nx/core/lib/interfaces/hal.interface';
import { stripHAL } from '@valk-nx/core/lib/interfaces/hal.interface';
import { fetchWithTransferState } from '@valk-nx/core/lib/ssr/ssr.helper';

export const LEGAL_DATA_URL = new InjectionToken<URL>('legal-data-url');

@Injectable({ providedIn: 'root' })
export class LegalService {
	private readonly http = inject(HttpClient);
	private readonly transferState = inject(TransferState);
	private readonly legalDataUrl = inject(LEGAL_DATA_URL);

	getLegalText(language: string) {
		const url = new URL(this.legalDataUrl);
		url.searchParams.append('language', language);

		return fetchWithTransferState<HALResponse<string>>(
			this.transferState,
			this.http,
			url.toString(),
			url.toString(),
		).pipe(stripHAL);
	}
}
